import { render } from "./GovernmentMaster.vue?vue&type=template&id=265f002e&scoped=true"
import script from "./GovernmentMaster.vue?vue&type=script&lang=js"
export * from "./GovernmentMaster.vue?vue&type=script&lang=js"

import "./GovernmentMaster.vue?vue&type=style&index=0&id=265f002e&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265f002e"]])

export default __exports__